import React, { useState } from 'react';
import { gallery } from '../data/mock';

const Galleria = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tutti');
  
  const categories = ['Tutti', ...new Set(gallery.map(item => item.category))];
  
  const filteredGallery = selectedCategory === 'Tutti' 
    ? gallery 
    : gallery.filter(item => item.category === selectedCategory);

  return (
    <div className="galleria-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-title">Galleria <span className="text-brand-red">Lavori</span></h1>
          <div className="accent-line"></div>
          <p className="body-large text-secondary" style={{ maxWidth: '800px', marginTop: '1.5rem' }}>
            Esempi dei nostri progetti di segnaletica stradale e industriale
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section">
        <div className="container">
          <div className="gallery-grid">
            {filteredGallery.map((item) => (
              <div key={item.id} className="gallery-item">
                <div className="gallery-image-wrapper">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="gallery-image"
                  />
                </div>
              </div>
            ))}
          </div>

          {filteredGallery.length === 0 && (
            <div className="no-results">
              <p className="body-large text-secondary">
                Nessun progetto trovato in questa categoria
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Info Section */}
      <section className="section section-blue-tint">
        <div className="container">
          <div className="info-content">
            <h2 className="section-title">Progetti su Misura</h2>
            <div className="accent-line"></div>
            <p className="body-large" style={{ marginTop: '1.5rem', lineHeight: '1.8' }}>
              Ogni progetto che realizziamo è unico e personalizzato secondo le esigenze specifiche 
              del cliente. Dalla piccola area di parcheggio ai grandi magazzini logistici, dalla 
              segnaletica stradale alle installazioni industriali complesse.
            </p>
            <p className="body-large" style={{ marginTop: '1rem', lineHeight: '1.8' }}>
              Collaboriamo con i più grandi nomi della logistica, della GDO e del retail in tutta 
              Italia, garantendo sempre la massima qualità e conformità normativa.
            </p>
          </div>
        </div>
      </section>

      <style jsx>{`
        .galleria-page {
          padding-top: 80px;
        }

        .page-hero {
          padding: var(--space-xl) 0 var(--space-lg);
          background: var(--bg-page);
        }

        /* Filter Section */
        .filter-section {
          background: var(--bg-page);
          padding: var(--space-md) 0;
          border-bottom: 2px solid var(--brand-blue);
        }

        .filter-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          justify-content: center;
        }

        .filter-btn {
          background: transparent;
          color: var(--text-secondary);
          border: 1px solid var(--border-light);
          border-radius: 10rem;
          padding: 0.75rem 1.5rem;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .filter-btn:hover {
          border-color: var(--brand-blue);
          color: var(--brand-blue);
        }

        .filter-btn-active {
          background: var(--brand-blue);
          color: white;
          border-color: var(--brand-blue);
        }

        /* Gallery Grid */
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-sm);
        }

        @media (max-width: 1024px) {
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .gallery-grid {
            grid-template-columns: 1fr;
          }
        }

        .gallery-item {
          position: relative;
          overflow: hidden;
          background: var(--bg-card);
          aspect-ratio: 4/3;
        }

        .gallery-image-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .gallery-item:hover .gallery-image {
          transform: scale(1.1);
        }

        .gallery-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
          display: flex;
          align-items: flex-end;
          padding: 1.5rem;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .gallery-item:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-info {
          width: 100%;
        }

        .gallery-category {
          color: var(--brand-orange);
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 0.5rem;
        }

        .gallery-title {
          color: white;
          font-size: 1.25rem;
          font-weight: 700;
        }

        /* No Results */
        .no-results {
          text-align: center;
          padding: var(--space-xl) 0;
        }

        /* Info Content */
        .info-content {
          max-width: 900px;
          margin: 0 auto;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default Galleria;
